import { SOPWorkflowState } from '@hakimo-ui/hakimo/types';
import { createContext, useContext } from 'react';

const defaultValue: SOPWorkflowState = {
  logCallFromSOP: () => {
    return;
  },
};

export const SOPWorkflowStateContext = createContext(defaultValue);

export function useSOPWorkflowState() {
  const sopWorkflowState = useContext(SOPWorkflowStateContext);
  return sopWorkflowState;
}
